<figure *ngIf="!showEmptyState; else emptyState" class = 'highcharts-figure'>
    <div id="bestDealWorstDealChart"></div>
</figure>
<ng-template #emptyState><app-empty-chart [additionalStyle]="'bg-85pcnt'"></app-empty-chart> </ng-template>
